export default "__VITE_ASSET__BYwUuqpq__"